import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { applyTheme, getStoredTheme } from '../lib/theme';
import type { ThemeMode } from '../lib/theme';
import { IconSun, IconMoon } from './Icons';

// Cycles system -> light -> dark. Icon reflects the *effective* appearance.
export function ThemeToggle() {
  const { t } = useTranslation();
  const [mode, setMode] = useState<ThemeMode>(() => getStoredTheme());

  useEffect(() => {
    applyTheme(mode);
  }, [mode]);

  const next: Record<ThemeMode, ThemeMode> = { system: 'light', light: 'dark', dark: 'system' };
  const label =
    mode === 'system' ? t('app.themeSystem') : mode === 'light' ? t('app.themeLight') : t('app.themeDark');

  const prefersDark =
    typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches;
  const effectiveDark = mode === 'dark' || (mode === 'system' && prefersDark);

  return (
    <button
      type="button"
      className="icon-btn"
      onClick={() => setMode((m) => next[m])}
      aria-label={`${t('app.theme')}: ${label}`}
      title={`${t('app.theme')}: ${label}`}
    >
      {effectiveDark ? <IconMoon width={18} height={18} /> : <IconSun width={18} height={18} />}
    </button>
  );
}
